export function applyTelegramTheme(webApp = window.Telegram?.WebApp): () => void {
  if (!webApp) return () => undefined;
  const update = () => {
    document.documentElement.dataset.theme = webApp.colorScheme;
  };
  update();
  webApp.onEvent?.("themeChanged", update);
  return () => webApp.offEvent?.("themeChanged", update);
}
